export interface Admin {
  id: string;
  name: string;
  username?: string | null;
  email: string;
  phone?: string;
  employeeId?: string;
  designation?: string;
  department?: string;
  panNumber?: string;
  bankName?: string;
  accountNumber?: string;
  ifscCode?: string;
  uanNumber?: string;
  pfAccountNumber?: string;
  esiNumber?: string;
  aadharNumber?: string;
  dob?: string;
  emergencyContactNumber?: string;
  emergencyContactRelation?: string;
  isActive?: boolean;
  appAccessEnabled?: boolean;
  role: string;
  permissions: Record<string, boolean>;
  assignedKitchenIds?: string[];
  hasGlobalKitchenAccess?: boolean;
}

export interface LoginResponse {
  token: string;
  admin: Admin;
}

export const ADMIN_PERMISSION_KEYS = [
  "analytics",
  "orders",
  "subscriptions",
  "users",
  "deliveryAgents",
  "discounts",
  "meals",
  "nowMeals",
  "swapSets",
  "kitchens",
  "holidays",
  "admins",
  "instantOrders",
] as const;

export type AdminPermissionKey = typeof ADMIN_PERMISSION_KEYS[number];

export const ADMIN_ROLE_OPTIONS = [
  "super-admin",
  "admin",
  "manager",
  "kitchen-staff",
] as const;

export type AdminRole = typeof ADMIN_ROLE_OPTIONS[number];

export interface OperatingHour {
  dayOfWeek: "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday" | "sunday";
  opensAt: string;
  closesAt: string;
  isClosed?: boolean;
}

export interface Kitchen {
  _id: string;
  name: string;
  address: string;
  pin: string;
  capacity?: number;
  kitchenLevel?: number;
  isActive: boolean;
  isOpen: boolean;
  rawIsOpen?: boolean;
  operationalStatus?: "OPEN" | "TEMPORARILY_CLOSED" | "OFF_HOURS";
  isWithinOperatingHours?: boolean;
  allowCartBuilding?: boolean;
  nextOpensAt?: string | null;
  nextOpensAtFormatted?: string | null;
  statusMessage?: string;
  operatingHours?: OperatingHour[];
  coordinates?: {
    latitude?: number;
    longitude?: number;
  };
  logisticsConfig?: {
    basePrepTime?: number;
    busyThreshold?: number;
    busyPenalty?: number;
    largeCartThreshold?: number;
    largeCartPenalty?: number;
    isRainMode?: boolean;
    rainPenalty?: number;
    baseDeliveryTimeNear?: number;
    baseDeliveryTimeFar?: number;
  };
}
